module.exports = __webpack_public_path__ + "img/smg.thompson.8cdd6af6.png";